document.addEventListener('DOMContentLoaded', function () {
	function hideProductVariants() {
		if (!window.asl_variants) {
			return;
		}

		let productVariants = window.asl_variants
		if (Object.keys(productVariants)) {
			for (const key in productVariants) {
				if (!key || theme.getUrlParameter('variant') !== key.toString()) {
					continue;
				}
				if (productVariants[key] <= 0) {
					let subBlock = document.querySelector('.rtx-subscription')
					if (subBlock) {
						subBlock.style.display = 'none'
					}
					const themeMoney = document.querySelector('.current-price.theme-money');
					if (themeMoney) {
						themeMoney.remove()
					}
					document.querySelector('.price-area.product-detail__gap-sm').innerHTML = '<span>Sold Out</span>'
				}
			}
		}
	}
	
	setTimeout(function () {
		hideProductVariants()
	}, 1000)

let variationSelector = document.querySelector('.option-selectors select')
	variationSelector.addEventListener('change', function () {
      setTimeout(function () {
		hideProductVariants()
        }, 1000)
	})
})






